import styled from 'styled-components';

export const InfoVerticalListViewGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  gap: var(--radius-large, 16px);

  padding: 24px var(--radius-large, 16px);
`;
